import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Download an admin dataset as CSV (cookie-authenticated).
 * dataset: 'sales' | 'commission-invoices' | 'rh-commissions' | 'users'
 */
export const exportDataset = async (dataset, filenameHint) => {
  try {
    const res = await fetch(`${API}/admin/export/${dataset}`, { credentials: 'include' });
    if (!res.ok) {
      toast.error("Export impossible");
      return;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filenameHint || dataset}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success('Export téléchargé');
  } catch (e) {
    toast.error("Export impossible");
  }
};


/** Download a certified, watermarked PDF of a conversation thread. */
export const exportConversationPdf = async (partnerId) => {
  try {
    const res = await fetch(`${API}/messages/conversation/${partnerId}/export-pdf`, { credentials: 'include' });
    if (!res.ok) {
      toast.error("Export PDF impossible");
      return;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'conversation_GROUPE-LNC.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success('Conversation exportée (PDF certifié)');
  } catch (e) {
    toast.error("Export PDF impossible");
  }
};
